import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// Optional: fetch common details from localStorage for header
const getCommonExcelDetails = () => {
  return {
    savedFromDate: localStorage.getItem("savedFromDate"),
    savedToDate: localStorage.getItem("savedToDate"),
    user: JSON.parse(localStorage.getItem("user")),
  };
};

export const generateExcelFile = async (
  data,
  filename = "Export.xlsx",
  sheetName = "Sheet1",
  transformData = null,
  sheetHeading = "",
) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  const { savedFromDate, savedToDate, user } = getCommonExcelDetails();
  const companyName = user?.data?.company_name || "N/A";
  const address = user?.data?.address || "N/A";

  // Apply transformation if needed
  const transformedData = transformData ? transformData(data) : data;

  const formatDate = (dateString) => {
    return dateString
      ? new Date(dateString).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "";
  };

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  // Add header section (optional)
  // const headerSection = [
  //   ["Company Name", `: ${companyName}`],
  //   ["Address", `: ${address}`],
  //   ["Date", `: ${formatDate(savedFromDate)} To ${formatDate(savedToDate)}`],
  //   [],
  //   [sheetHeading || "Exported Data"],
  //   [],
  // ];

  // headerSection.forEach((row, idx) => {
  //   const excelRow = worksheet.addRow(row);
  //   if ([0, 1, 2, 4].includes(idx)) {
  //     excelRow.font = { bold: true, size: 14 };
  //   }
  // });

  // Add table headers
  const headers = Object.keys(transformedData[0]);
  const headerRow = worksheet.addRow(headers);
  headerRow.font = { bold: true, size: 12 };

  // Add table rows
  transformedData.forEach((row) => {
    const rowData = Object.values(row);
    worksheet.addRow(rowData);
  });

  // Auto column width
  worksheet.columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellLength = cell.value ? cell.value.toString().length : 10;
      if (cellLength > maxLength) maxLength = cellLength;
    });
    column.width = maxLength + 2;
  });

  // Save the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, filename);
};
